import { Link } from 'react-router-dom';

import appleImage from './images/download-appstore.svg';
import googleImage from './images/download-playstore.svg';
import { constants } from '../../constants';
import { t } from '../../services/translation/translation';

export const DiscoverAllocab = () => {
  return (
    <>
      <div className="flex flex-col justify-center gap-y-2">
        <button className="w-full px-4 py-2 border-2 border-success bg-success text-text_light hover:text-success hover:bg-background">
          <a target="blank" href="https://www.allocab.com/fr/">
            {t('share-route.discover.website')}
          </a>
        </button>

        <small className="text-center my-2">
          {t('share-route.discover.allready')}
          <Link to={`${constants.legacyWebappHost}/#/auth/`} className="text-cta ml-1">
            {t('share-route.discover.login')}
          </Link>
        </small>
      </div>

      <hr />

      <div className="flex flex-col justify-center mt-2 gap-y-2">
        <strong className="text-center mb-2"> {t('share-route.discover.app')}</strong>
        <a
          target="blank"
          href="https://apps.apple.com/fr/app/allocab-chauffeur-prive-vtc/id562233261"
          className="flex justify-center"
        >
          <img className="h-12 w-auto" alt="appStore" src={appleImage} />
        </a>
        <a
          target="blank"
          href="https://play.google.com/store/apps/details?id=com.allocab.allocabpassenger&hl=fr_FR"
          className="flex justify-center"
        >
          <img className="h-12 w-auto" alt="playStore" src={googleImage} />
        </a>
      </div>
    </>
  );
};
